import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const Welcomekits =()=>{
    const CTAContent = [
        {
          pageName: "Welcome Kits",
          paragraphitalic: "A Thoughtful Introduction to Your Brand",
          paragraphText:
                "Our Welcome Kits are more than just a collection of items—they’re a powerful introduction to your company’s values, vision, and team. These kits are designed to ensure new employees feel appreciated, motivated, and ready to take on the world",
          ContactFormName: "Welcome Kits",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Eco-Friendly Products",
          parapgraphItalic: "Sustainability Meets Style",
          sectionparagraphText: (
            <>
              <p>
              Reduce your footprint without compromising quality or aesthetics. 
                </p>
                <p>
                Make an impact that matters with our range of eco-friendly products. Crafted from sustainable materials, these items are perfect for businesses looking to align with green initiatives while delighting employees, clients, and event attendees. Whether it's bamboo desk essentials or reusable drinkware, each product speaks of your commitment to a better planet. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Welcome Kits/Eco-Friendly Products.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Exclusive Company Swag",
          parapgraphItalic: "Swag That Stands Out – Because Ordinary is Overrated!",
          sectionparagraphText: (
            <>
              <p>
              Exclusive merchandise that turns heads and wins hearts. 
                </p>
                <p>
                Step up your branding game with exclusive company swag that’s as unique as your business. From quirky desk toys to premium tech accessories, our customized swag helps your brand stay top-of-mind while adding a dash of fun and utility. Perfect for giveaways, onboarding, or special events, this is branding with a personal touch. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Welcome Kits/Exclusive Company Swag.jpg",
          categoryHeadingLeftSide: "Features That Swaggers",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Welcome Kits/Customizable Everything.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Customizable Everything</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Welcome Kits/Premium Selection.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Premium Selection</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Welcome Kits/Memorable Designs.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Memorable Designs</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/Welcome Kits/Features That Put the Planet First.jpg",
          NogapHeading: "Features That Put the Planet First",
          Heading: [
            {
              ListHeading: "Sustainable Materials",
              ListParagraph:
                "From bamboo and recycled plastic to organic fabrics.",
            },
            {
              ListHeading: "Practical & Stylish",
              ListParagraph:
                "Functional items with a modern, minimalist design.",
            },
            {
              ListHeading: "Custom Branding",
              ListParagraph:
                "Showcase your logo on eco-conscious products for memorable gifting.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/Welcome Kits/Company-Branded Apparel & Accessories.jpg",
          NogapHeading: "Company-Branded Apparel & Accessories",
          paragraphItalic: "Wear Your Brand with Pride!",
          paragraphDetail: (
            <>
              <p>
              Stylish, high-quality apparel and accessories that bring teams together. 
                </p>
                <p>
                Turn your team into brand ambassadors with company-branded apparel and accessories. From premium t-shirts and hoodies to caps and tote bags, our offerings ensure your brand stands out. Perfect for corporate events, team building, or everyday wear, these items showcase your identity in style. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Define Your Brand",
          Categories: [
            {
              ServiceImg: "../assests/images/Welcome Kits/High-Quality Fabrics.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>High-Quality Fabrics</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Welcome Kits/Custom Design Options.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Custom Design Options</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Welcome Kits/Wide Range of Products.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Wide Range of Products</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>eYantra Rewards & Corporate Gifting</title>
        <meta name="description" content="eYantra provides employee recognition gifts, branded merchandise, joining kits, and bulk gifting solutions with corporate gifts and welcome kits for every need."/>
        <meta name="keywords" content="eyantra, employee recognition, reward and recognition,  branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        From branded goodies to personalized surprises, create an immediate connection with employees by providing a kit that reflects your company’s unique culture.
      </p>
    </>
  );
};

export default Welcomekits;